import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const useServiceWorkerStore = create()(
  devtools(() => ({
    isUpdateAvailable: false,
  }))
);
